if (!customElements.get("delivery-estimation")) {
  customElements.define(
    "delivery-estimation",
    class DeliveryEstimation extends DeployerElement {
      constructor() {
        super();
      }

      connectedCallback() {
        super.connectedCallback();
        this.init();
      }

      setupVariables() {
        this.shopLocale = this.dataset.shopLocale;

        this.delivery = {
          container: this.querySelector(".delivery-estimation__delay-container"),
          delayContainer: this.querySelector(".delivery-estimation__delay-container"),
          minimumDelay: this.querySelector("#datemin"),
          maximumDelay: this.querySelector("#datemax"),
          countdown: this.querySelector("#countdown"),
        };

        this.translation = JSON.parse(this.querySelector('[type="application/json"]').textContent);

        this.CSSClass = {
          available: "stock-indic--available",
          low: "stock-indic--low",
          out: "stock-indic--out",
        };

        this.variantElms = document.querySelectorAll(".product-variant");
        this.currentVariantId = this.querySelector(".stock-disp-cont").dataset.currentVariantId;
      }

      setupEvents() {
        document.addEventListener(deployerEvents.variantChange, (event) => {
          this.currentVariantId = event.detail.variant.id;
          this.init();
        });
      }

      init() {
        this.variantsObj = [];

        this.variantElms.forEach((variantElm) => {
          this.variantsObj.push({
            id: variantElm.dataset.variantId,
            inventory_qty: variantElm.dataset.variantInventoryQty,
          });
        });

        const stockIndic = document.querySelector(".stock-indic");
        const classesToRemove = [this.CSSClass.low, this.CSSClass.out, this.CSSClass.available];

        classesToRemove.forEach((cssClass) => {
          if (stockIndic.classList.contains(cssClass)) {
            stockIndic.classList.remove(cssClass);
          }
        });

        const varIndex = this.variantsObj.findIndex((o) => parseInt(o.id) === parseInt(this.currentVariantId));
        const varQuantity = parseInt(this.variantsObj[varIndex].inventory_qty);
        const stockDisp = document.querySelector(".stock-disp");

        if (varQuantity >= 20) {
          stockDisp.innerHTML = this.translation.available;
          stockIndic.classList.add(this.CSSClass.available);
        } else if (varQuantity < 20 && varQuantity > 0) {
          stockDisp.innerHTML = `${this.translation.low_before} ${varQuantity} ${this.translation.low_after}`;
          stockIndic.classList.add(this.CSSClass.low);
        } else if (varQuantity <= 0) {
          stockDisp.innerHTML = `${this.translation.unavailable}`;
          stockIndic.classList.add(this.CSSClass.out);
        }

        this.updateDeliveryDelay();

        if (this.delivery.countdown) {
          this.startCountdown();
        }
      }

      updateDeliveryDelay() {
        const today = new Date();
        let datesDelai;

        if (this.delivery.delayContainer.dataset.max === "0") {
          datesDelai = this.getDatesDelai(today, parseInt(this.delivery.delayContainer.dataset.min));
        } else {
          datesDelai = this.getDatesDelai(today, parseInt(this.delivery.delayContainer.dataset.min), parseInt(this.delivery.delayContainer.dataset.max));
        }

        this.delivery.minimumDelay.innerHTML = this.formatDate(datesDelai["dmin"]);

        if (this.delivery.delayContainer.dataset.max !== "0") {
          this.delivery.maximumDelay.innerHTML = this.formatDate(datesDelai["dmax"]);
        }
      }

      /**
       * @param {Date} date
       * @returns {String}
       */
      formatDate(date) {
        const options = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
        return new Date(date).toLocaleDateString(this.dataset.shopLocale, options);
      }

      /**
       * @param {Date} date
       * @param {Number} delaiMin
       * @param {Number} delaiMax
       * @returns {Object}
       */
      getDatesDelai(date, delaiMin, delaiMax = delaiMin) {
        const result = {};
        const currentDay = date.getDay();
        const currentHour = date.getHours();

        let minDelay = delaiMin;
        let maxAdditionalDelay = delaiMax;

        switch (currentDay) {
          case 0: // Dimanche
            minDelay = delaiMin + 2; // (J+2)
            break;

          case 1: // Lundi
            minDelay = delaiMin + 1; // (J+2)
            maxAdditionalDelay = delaiMax; // (J+1)
            break;

          case 2: // Mardi
            currentHour < 12
              ? (minDelay = delaiMin) // (J+1)
              : (minDelay = delaiMin + 1); // (J+2)
            break;

          case 3: // Mercredi
            currentHour < 12
              ? (minDelay = delaiMin) // (J+1)
              : (minDelay = delaiMin + 1); // (J+2)
            break;

          case 4: // Jeudi
            currentHour < 12
              ? (minDelay = delaiMin) // (J+1)
              : (minDelay = delaiMin + 1); // (J+2) et (J+3)
            break;

          case 5: // Vendredi
            currentHour < 12
              ? (minDelay = delaiMin && maxAdditionalDelay++) // (J+1) et (J+2)
              : (minDelay = delaiMin + 3); // (J+3)
            break;

          case 6: // Samedi
            minDelay = delaiMin + 3; // (J+3)
            break;

          default:
            minDelay = delaiMin;
        }

        result.dmin = this.addBusinessDays(date, minDelay);
        result.dmax = this.addBusinessDays(result["dmin"], maxAdditionalDelay);

        return result;
      }

      /**
       *
       * @param {Date} startDate
       * @param {Number} numberOfBusinessDays
       * @returns {Date}
       */
      addBusinessDays(startDate, numberOfBusinessDays) {
        let date = new Date(startDate.getTime());
        while (numberOfBusinessDays > 0) {
          date.setDate(date.getDate() + 1);
          if (date.getDay() !== 0) {
            numberOfBusinessDays--;
          }
        }
        return date;
      }
    }
  );
}
